import { AlertCircle } from 'lucide-react';
import { useI18n } from '../i18n/useI18n';

const objections = [
  'problem.item.later',
  'problem.item.changed',
  'problem.item.object',
  'problem.item.gallery',
  'problem.item.time',
  'problem.item.backdated',
];

export function ProblemSection() {
  const { t } = useI18n();

  return (
    <section className="section">
      <div className="section-heading">
        <p className="eyebrow">{t('problem.eyebrow')}</p>
        <h2>{t('problem.title')}</h2>
        <p>{t('problem.text')}</p>
      </div>
      <div className="objection-grid">
        {objections.map((item) => (
          <div className="objection" key={item}>
            <AlertCircle size={18} />
            {t(item)}
          </div>
        ))}
      </div>
      <p className="section-note">{t('problem.note')}</p>
    </section>
  );
}
